import { ExpandableContentWrapper } from 'components';
import { EquityPCRatioChart } from 'components/sentiment/EquityPCRatioChart';
import { CanvasContentId } from 'types/canvas';

const CanvasEquityPCRatio = () => (
  <ExpandableContentWrapper
    type={CanvasContentId.EQUITY_PUT_CALL_RATIO_CHART}
    styleOverrides={{ p: 1, height: '100%' }}
  >
    <EquityPCRatioChart />
  </ExpandableContentWrapper>
);

export default CanvasEquityPCRatio;
